export const TEXT_STYLE = {
  fontFamily: "MD Primer",
  fontWeight: "regular",
  fontSize: 12,
  fill: "#676767",
};

export const X_AXIS_LABEL_KEY = "xAxisLabel";

export const BAR_COLORS = [
  "#8DF7B4",
  "#C2132E",
  "#DE223E",
  "#CDF4FF",
  "#7A25F0",
  "#BE90FD",
  "#44E47E",
  "#6C17E3",
  "#F14761",
  "#E0CBFF",
  "#FFBFC8",
  "#FB8F9F",
  "#CC9900",
  "#0E873A",
  "#8DFFF7",
  "#FFE9A7",
  "#0E6B87",
  "#44BEE4",
  "#F3C435",
  "#E3AE0E",
  "#1D98BD",
  "#FCDE84",
  "#CEFFE0",
  "#934AF9",
  "#1DBD58",
];
